import { RequestOptions, Response, Request, RequestOptionsArgs, Headers, Http } from "@angular/http";
import { Observable } from "rxjs";
import { AuthHttp, AuthConfig, tokenNotExpired } from "angular2-jwt";
import { AuthService } from "../auth/auth.service";
import { environment } from "../../../environments/environment";

export class AuthHttpInterceptor extends AuthHttp {

    constructor(http: Http, defaultOptions: RequestOptions, private authService: AuthService) {
        super(new AuthConfig({
            headerName: 'Authorization',
            headerPrefix: 'Bearer',
            globalHeaders: [{ 'Content-Type': 'application/json' }],
            tokenName: 'token',
            tokenGetter: (() => (localStorage.getItem('token'))),
            noJwtError: false
        }), http, defaultOptions)
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        if (tokenNotExpired()) {
            this.authService.refreshToken();
        }

        return this.intercept(super.request(url, options));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.get(url, options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.delete(url, options));
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        options.headers.append('Content-Type', 'application/json');
        return options;
    }

    private isUnauthorized(status: number): boolean {
        return status === 0 || status === 401 || status === 403;
    }

    private notAllowed(status: number): boolean {
        return status === 405;
    }

    intercept(observable: Observable<Response>): Observable<Response> {
        return observable.catch((err, source) => {
            if (tokenNotExpired() == false) {
                this.authService.logout();

                return Observable.empty();
            } else if (this.notAllowed(err.status)) {
                return Observable.throw(new Error('Your security credentials do not suport this functionality.'));
            } else if (this.isUnauthorized(err.status)) {
                this.authService.logout();

                //if (err instanceof Response) {
                //    return Observable.throw(err.json().message || 'backend server error');
                //}
                return Observable.empty();
            }
            else {
                if (environment.debugLevel > 0) {
                    console.log(err);
                }
                return Observable.throw(err.message || 'backend server error');
            }
        });
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/auth/authHttp.interceptor.ts